import { render, staticRenderFns } from "./UsageNationalData.vue?vue&type=template&id=448dc28d&scoped=true&"
import script from "./UsageNationalData.vue?vue&type=script&lang=js&"
export * from "./UsageNationalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dc28d",
  null
  
)

export default component.exports